<template>
    <div>
        <!-- 主表、台账等 -->
        <Basicform v-if="formType === 'mainform'" :title="formTitle" :win-width="mainModuleInfo.winWidth" :win-height="mainModuleInfo.winHeight" :toolbar-btns="busiformBtns" :on-basic-form-before-open="onMainBasicFormBeforeOpen" :on-basic-form-opened="onMainBasicFormOpened" :on-basic-form-before-submit="onMainBasicFormBeforeSubmit" :on-basic-form-submited="onMainBasicFormSubmited">
            <template #default="slotProps">
                <busi-form :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="mainModuleInfo" />
            </template>
        </Basicform>

        <!--修改添加 -->
        <Basicform v-if="formType === 'subform'" :title="formTitle" :win-width="subModuleInfo.winWidth" :win-height="subModuleInfo.winHeight" :toolbar-btns="subBusiformBtns" :on-basic-form-before-open="onSubBasicFormBeforeOpen" :on-basic-form-opened="onSubBasicFormOpened" :on-basic-form-before-submit="onSubBasicFormBeforeSubmit" :on-basic-form-submited="onSubBasicFormSubmited">
            <template #default="slotProps">
                <busi-form :vo="slotProps.vo" :can-edit="slotProps.canEdit" :module-info="subModuleInfo" />
            </template>
        </Basicform>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            formTitle: '',
            formType: '',
            subModuleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/clgl/clxx/form2.html',
                winWidth: 1000,
                delUrl: 'clgl/clxx/delete',
                addNewUrl: 'clgl/clxx/addNew',
                insertUrl: 'clgl/clxx/insert',
                moduleCode: 'clglClxx',
                winHeight: 600,
                updateUrl: 'clgl/clxx/update',
                listDataUrl: 'clgl/clxx/listdata',
                getByIdUrl: 'clgl/clxx/getById'
            },
            mainModuleInfo: {
                formTemplate: 'dcontent/busiformurl?vwtype=W&url=/clgl/clxx/form.html',
                winWidth: 1000,
                delUrl: 'clgl/clxx/delete',
                addNewUrl: 'clgl/clxx/addNew',
                insertUrl: 'clgl/clxx/insert',
                moduleCode: 'clglClxx',
                winHeight: 600,
                updateUrl: 'clgl/clxx/update',
                listDataUrl: 'clgl/clxx/listdata',
                getByIdUrl: 'clgl/clxx/getById'
            },
            busiformBtns: [
                {
                    id: 'btn_edit',
                    btnName: '修改',
                    btnIcon: 'edit',
                    btnClick: this.editBusiform,
                    btnPermission: 'editObject',
                    btnStyleType: 'default'
                },
                {
                    id: 'btn_close',
                    btnName: '关闭',
                    btnIcon: 'close',
                    btnClick: 'closeDialog',
                    btnPermission: '',
                    btnStyleType: 'default'
                }
            ],
            subBusiformBtns: [],
            row: {}
        }
    },
    computed: {},
    watch() {
        //  this.$options.components['transferForm'] = this.$loadComponent('@/wapp/clgl/clxx/components/TransferForm')
    },
    created() {
        this.$bus.on('showMainForm', this.showMainForm)
        //    this.$bus.on('editSubForm', this.editSubForm)
        // this.$bus.on('addNewSubForm', this.addNewSubForm)
    },
    beforeDestroy() {
        this.$bus.off('showMainForm', this.showMainForm)
        //  this.$bus.off('editSubForm', this.editSubForm)
    },
    mounted() {},
    methods: {
        editBusiform() {
            this.editSubForm(this.row)
        },
        showMainForm(v) {
            this.row = v
            this.formType = 'mainform'
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.mainModuleInfo, v, 0)
            })
        },
        editSubForm(v) {
            this.formType = 'subform'
            this.$nextTick(() => {
                this.$bus.emit('openBusiform', this.subModuleInfo, v, 1)
            })
        }
        // addNewSubForm() {
        //     this.formType = 'subform'
        //     this.$nextTick(() => {
        //         this.$bus.emit('openBusiform', this.subModuleInfo, null, 1)
        //     })
        // }
    }
}
</script>

<style scoped lang="scss">
</style>
